import { Identifier, SimpleForm, useGetIdentity, useGetList, useGetOne } from "react-admin"
import { InvoiceType } from "../GeneratedClients/FreeBillApi"
import { useState } from "react"
import InvoiceFormToolbar from "./form/InvoiceFormToolbar"
import InvoiceTypeCard from "./form/cards/InvoiceTypeCard"
import InvoiceAdressCard from "./form/cards/InvoiceAdressCard"
import Form from "../inputFormComponents/Form"
import InvoiceItemsCard from "./form/cards/InvoiceItemsCard"
import TotalAmount from "./form/TotalAmount"
import FormCardTextModel from "../textModel/FormCardTextModel"
import textModelTemplate from "../fixtures/textModelTemplate"
import DescriptionInvoiceType from "./form/cards/descriptions/DescriptionInvoiceType"
import DescriptionInvoiceAdress from "./form/cards/descriptions/DescriptionInvoiceAddress"
import DescriptionTextTemplates from "./form/cards/descriptions/DescriptionTextTemplates"
import WarningNoTaxInfo from "./WarningNoTaxInfo"
import CompleteUserDataDialog from "./actionDialogs/CompleteUserDataDialog"
import AddNumberRangeDialog from "./actionDialogs/AddNumberRangeDialog"

interface IProps {
  resource?: 'invoices' | 'drafts'
  draftId?: Identifier
}

const FormInput = ({resource,draftId}: IProps) => {

  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id}, {enabled: !identityLoading})
  const { data: numberRanges, isLoading: numberRangesLoading} = useGetList("numberRanges")

  const [invoiceType, setInvoiceType] = useState<InvoiceType>(InvoiceType.StandardInvoice)
  
  const defaultDuePeriod = user?.defaultDuePeriod ?? 10
  const invoiceDate = new Date()
  const dueDate = new Date().setDate(new Date().getDate() + defaultDuePeriod)
  const textModel = user?.textModel ? user?.textModel : textModelTemplate
  const configTextModel = "show"
  const isNoTaxInfo = (!user?.taxNumber && !user?.ustId) || (user?.ustId && user?.isUstIdHidden)
  const noBankAccount = user?.bankAccount === null
  const noNumberRange = numberRanges?.length === 0

  const cards = [
    <InvoiceTypeCard 
      key={1}
      description={<DescriptionInvoiceType />} 
      setInvoiceType={setInvoiceType} 
      isSmallBusiness={user?.isSmallBusiness} 
      defaultInvoiceDate={new Date(invoiceDate).toISOString()} 
      defaultDueDate={draftId ? undefined : new Date(dueDate).toISOString()}
    />,
    <InvoiceAdressCard key={2} description={<DescriptionInvoiceAdress />} invoiceType={invoiceType} />,
    <FormCardTextModel 
      key={3}
      description={<DescriptionTextTemplates />} 
      invoiceType={invoiceType} 
      hideAction 
      initConfigTextModel={configTextModel} 
      textModel={textModel} 
    />,
    <InvoiceItemsCard key={4} invoiceType={invoiceType} isSmallBusiness={user?.isSmallBusiness} />
  ]

  if(identityLoading || userLoading || numberRangesLoading) return null

  return (
    <SimpleForm onSubmit={() => {}} toolbar={<InvoiceFormToolbar resource={resource} draftId={draftId} invoiceType={invoiceType} />}>
      { isNoTaxInfo && <WarningNoTaxInfo userId={user.id} /> }
      { noNumberRange && <AddNumberRangeDialog /> }
      { (!noNumberRange && noBankAccount) && <CompleteUserDataDialog /> }
      <Form cards={cards} showCardNumbers={true} />
      <TotalAmount />
    </SimpleForm>
  )
}

export default FormInput